import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { selectFrame } from 'redux/db/reducers';
import { getFrameDisplayBounds } from 'redux/db/util';
import {
	centerCanvasAroundSceneBoundingBox,
	setCenteredFrameId,
	setCenterFramesForChatId,
	setSelected,
} from 'redux/mode/actions';
import { Pick } from 'redux/mode/classes';
import { selectIsMobile } from 'redux/mode/reducers';
import { RootReducer } from 'redux/reducers';
import * as S from './styles';

interface FrameLinkProps {
	frameId: string;
}

const FrameLink = ({ frameId }: FrameLinkProps) => {
	const dispatch = useDispatch();

	const { frame, isMobile } = useSelector(
		(r: RootReducer) => ({
			frame: selectFrame(r.db, frameId),
			isMobile: selectIsMobile(r.mode),
		}),
		shallowEqual
	);

	const onClick = (e: React.MouseEvent) => {
		e.preventDefault();
		e.stopPropagation();
		if (!frame) return;
		if (isMobile) {
			dispatch(setCenteredFrameId(frame.id));
		} else {
			dispatch(setCenterFramesForChatId(null));
			dispatch(
				centerCanvasAroundSceneBoundingBox({
					boundingBox: getFrameDisplayBounds(frame),
					animated: true,
					frameId: frame.id,
				})
			);
			dispatch(setSelected([new Pick(frame.id)]));
		}
	};

	if (!frame) {
		const truncated = frameId.slice(0, 8) + '...';
		return <S.MissingLink>{truncated}</S.MissingLink>;
	}

	const title = frame.title || 'Untitled';

	if (frame.deletedAt) {
		return <S.DeletedLink onClick={onClick}>{title}</S.DeletedLink>;
	}

	return <S.Base onClick={onClick}>{title}</S.Base>;
};

export default FrameLink;
